import React, { useEffect, useState } from "react";
import WarningModal from "../Modals/WarningModal";
import CustomModal from "../Modals/CustomModal";
import success from "../../../assets/pages/Section/Participants/attendee-upload/Success.svg";
import { regenerateTickets } from "../../../Utils/helpers";
import warning from "../../../assets/img/Models/warning.svg";
import { KonfhubButton } from "../Buttons";
import { successToaster, errorToaster } from "../../../reusable/common";
import { fetchTicketRegeneration } from "../../../revampCRUD/regenerateTickets.crud";


const RegenerateTickets = ({ eventId, bulkmodal, setBulkModal }) => {
    const [initiatedModal, setInitiatedModal] = useState(false)
    const [responseRegeneration, setResponseRegeneration] = useState([])
    const [isLoading, setIsLoading] = useState(true);


    const fetchData = async () => {
        try {
            setIsLoading(true);
            const response = await fetchTicketRegeneration(eventId);
            setResponseRegeneration(response.data);
        } catch (err) {
            console.error(err);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchData()
    }, [bulkmodal])


    const handleRegenerateTickets = () => {
        regenerateTickets(eventId)
        setInitiatedModal(true);
        setBulkModal(false);
    };

    return (
        <div>
            {/* Warning Modal */}
            <>
                {isLoading ? null : responseRegeneration?.length > 0 ? (<CustomModal
                    openModal={bulkmodal}
                    setOpenModal={setBulkModal}
                    saveBtnContent={null}
                    cancelBtnContent="Close"
                    paddingRequired="yes"
                    overflow="auto"

                    content={
                        <div className="modal-container">

                            <div className="icon-container">
                                <img src={warning} alt="Success" />
                            </div>
                            <div className="text-center note-box">
                                <div className="text-center ticket_progress mb-2"> Ticket Regeneration in Progress</div>
                            </div>
                            <div className="text-center custom_text_style"><p>Initiate the next generation once this is complete.</p></div>
                            <KonfhubButton
                                className="mr-0 mr-sm-3 mt-3 mt-sm-0"
                                onClick={() => setBulkModal(false)}
                                btnType="secondary"
                            >
                                Cancel
                            </KonfhubButton>
                        </div>
                    }
                    onCancel={() => setBulkModal(false)}
                />) : (
                    <WarningModal
                        openModal={bulkmodal}
                        setOpenModal={setBulkModal}
                        text={
                            "Are you sure you want to regenerate<br/>" +
                            "<b>all attendee tickets</b> to reflect the latest details<br/>" +
                            "(if any changes have been made) ?"
                        }

                        saveBtnContent={"Yes"}
                        cancelBtnContent="Cancel"
                        onCancel={() => setBulkModal(false)}
                        onOkay={handleRegenerateTickets}
                    />
                )}</>


            {initiatedModal && <CustomModal
                openModal={initiatedModal}
                setOpenModal={setInitiatedModal}
                saveBtnContent={null}
                cancelBtnContent="Close"
                paddingRequired="yes"
                overflow="auto"
                content={
                    <div className="modal-container">
                        <div className="icon-container">
                            <img src={success} alt="Success" />
                        </div>

                        <div className="note-box">
                            <p>
                                <b>Ticket regeneration initiated.</b> You will receive an email
                                once the process is complete.
                            </p>
                        </div>

                        <div className="message-box ">
                            <p>
                                <b>Note:</b> Regenerated tickets are not automatically sent to
                                attendees. Use <a href={`e/${eventId}/email`}>email campaigns</a> to notify them and share
                                the updated tickets after regeneration.
                            </p>
                        </div>
                    </div>
                }
                onCancel={() => setInitiatedModal(false)}
            />}

            {/* CSS Styles */}
            <style jsx>{`
				.form-heading {
					font-weight: 600;
					font-size: 15px;
					color: #572148;
				}
				.bulk_upload_modal_root {
					max-width: 485px;
				}
				.upload-container {
					text-align: center;
				}
				.ReactModal__Content--after-open {
					max-width: 50%;
					overflow: visible;
				}
				.bulk_upload_error_box {
					background: #FFDADE;
					border-radius: 6px;
				}
				.bulk_upload_error_text {
					font-size: 15px;
					color: #DC3545;
				}
                    .custom_text_style {
                        font-family: Hind;
                        font-size: 15px;
                        font-weight: 400;
                        line-height: 24px;
                        letter-spacing: 0em;
                        text-align: center;
                        color: #572148;
                    }

                    .ticket_progress{
                        font-size: 16px;
                        font-weight: 500;
                        line-height: 24px;
                        letter-spacing: 0em;
                        text-align: center;
                        color: #572148;
                    }


                    .modal-container {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        text-align: center;

                    }

                    .icon-container img {
                        width: 50px;
                        margin-bottom: 10px;
                    }

                    .message-box {
                        border: 1px solid #e2e2e2;
                        background: #f8f8f8;
                        border-radius: 8px;
                        padding: 12px;
                        font-size: 15px;
                        font-weight: 500;
                        color: #572148;
                        width: 100%;
                        max-width: 350px;
                    }

                    .note-box {
                        font-size: 16px;
                        font-weight: 400;
                        color: #572148;
                        width: 100%;
                        max-width: 350px;
                        
                    }

                    .note-box a {
                        color: #007bff;
                        text-decoration: none;
                        font-weight: bold;
                    }

                    @media (max-width: 450px) {
                        .bulk_upload_button {
                            margin-top: 10px;
                        }
				}
			`}</style>
        </div>
    );
};

export default RegenerateTickets;
